import styled from "styled-components";
import colors from "../../../styles/colors";
import fontSizes from "../../../styles/fontSizes";
import ClickableElement from "../../utils/ClickableElement";

export const SubmitButton = styled(ClickableElement)`
  display: flex;
  align-items: center;
  margin-right: 1rem;
  width: auto;
`;

export const EditRawButton = styled(SubmitButton)<{ selected: boolean }>`
  border: solid ${props => (props.selected ? colors.darkgrey : colors.lightgrey2)} 1px;
  background: ${props => (props.selected ? colors.lightgrey : "inherit")};
  border-radius: 1rem;
`;

export const Container = styled.div`
  background: white;
  padding: 1rem;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row-reverse;
`;

export const RawContentEdit = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  padding: 1rem;
  outline: 0 none;
  border-color: ${colors.darkgrey};
  background: ${colors.lightgrey}
  border-radius: 1rem;
  font-family: Menlo,Monaco,Consolas,“Courier New”,monospace;
  font-size: ${fontSizes.small};
`;
